import { getIntegerField } from '@lender/utils';

// Mirrors the API's ChattelDetailsRequestDtoValidator, which enforces GreaterThan(1900) and
// LessThanOrEqualTo(DateTime.UtcNow.Year + 1). The range is checked on save, not on keystroke:
// DataFieldCDS refuses any keystroke below its minValue, so a 4-digit minimum blocks every partial year.
const MIN_CHATTEL_YEAR_BUILT = 1901;

// Read on every schema build so a tab left open across New Year accepts next year's models.
const getMaxChattelYearBuilt = () => new Date().getUTCFullYear() + 1;

export const getChattelYearBuiltField = () => {
  const maxYearBuilt = getMaxChattelYearBuilt();

  return getIntegerField({ isRequired: false })
    .min(MIN_CHATTEL_YEAR_BUILT, `Year must be ${MIN_CHATTEL_YEAR_BUILT} or later`)
    .max(maxYearBuilt, `Year can't be after ${maxYearBuilt}`);
};
